var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotel-landing-app",class:("app-locale-" + (_vm.$i18n.locale))},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('notifications',{attrs:{"group":"notify"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }